import PropTypes from "prop-types";
import React from "react";
import Countdown from "./Countdown";
import moment from "moment";

const minute = 60;
const hour = 60 * minute;
const day = 24 * hour;

function calcRemainingTime(currentTime, endTime) {
  let timeleft = Math.floor((endTime - currentTime) / 1000);

  const days = Math.floor(timeleft / day);
  timeleft %= day;
  const hours = Math.floor(timeleft / hour);
  timeleft %= hour;
  const minutes = Math.floor(timeleft / minute);
  timeleft %= minute;
  const seconds = timeleft;

  return { days, hours, minutes, seconds };
}

export default class CountdownTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentTime: moment().valueOf() };
    this.tick = this.tick.bind(this);
  }

  componentDidMount() {
    const interval = this.props.interval | 1000;

    this.interval = setInterval(this.tick, interval);
  }

  tick() {
    this.setState({
      currentTime: new Date(),
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { endTime } = this.props;
    const { currentTime } = this.state;
    const remainingTime = calcRemainingTime(currentTime, endTime);

    return <Countdown {...remainingTime} />;
  }
}

CountdownTimer.propTypes = {
  interval: PropTypes.number,
  endTime: PropTypes.number,
};



// WEBPACK FOOTER //
// ./components/dashboard/CountdownTimer.js